import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";

const ReturnPolicy = () => {
  return (
    <div className="pp-page">
      <div className="pp-wrapper">
        {/* Header */}
        <div className="pp-header-section">
          <h1 className="pp-main-title">Return Policy</h1>
        </div>

        {/* Introduction */}
        <section className="pp-content-section">
          <p className="pp-intro-text">
            At Kitty n Mice, we want you to love what you buy. If something
            isn't quite right, we're here to help.
          </p>
        </section>

        {/* Eligibility for Returns */}
        <section className="pp-content-section pp-highlight-box">
          <h2 className="pp-section-title">1. Eligibility for Returns</h2>
          <div className="pp-return-notice">
            <div className="pp-notice-icon">🔄</div>
            <div className="pp-notice-text">
              <p className="pp-return-highlight">
                Returns are accepted within{" "}
                <strong className="pp-bold-red">7 days of delivery</strong>.
              </p>
              <ul className="pp-list">
                <li className="pp-list-item">
                  Items must be unused, unwashed, and in their original
                  condition, with all tags intact.
                </li>
                <li className="pp-list-item">
                  Products should be returned in their original packaging.
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Non-Returnable Items */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">2. Non-Returnable Items</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              Items purchased during sale or clearance are not eligible for
              return.
            </li>
            <li className="pp-list-item">
              Customized or altered products cannot be returned.
            </li>
            <li className="pp-list-item">
              Products showing signs of wear, damage, or washing will not be
              accepted.
            </li>
          </ul>
        </section>

        {/* Return Process */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">3. Return Process</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              To initiate a return, please contact us at{" "}
              <a href="mailto:kittynmice00@gmail.com" className="pp-link">
                kittynmice00@gmail.com
              </a>{" "}
              within 7 days of receiving your order.
            </li>
            <li className="pp-list-item">
              Once your return request is approved, we will share the return
              instructions.
            </li>
            <li className="pp-list-item">
              Customers are responsible for return shipping charges, unless the
              product received is damaged or incorrect.
            </li>
          </ul>
        </section>

        {/* Refunds */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">4. Refunds</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              After the returned item passes quality inspection, the refund will
              be processed within{" "}
              <strong className="pp-bold">5-7 business days</strong>.
            </li>
            <li className="pp-list-item">
              Refunds will be issued to the original mode of payment or as store
              credit, as applicable.
            </li>
          </ul>
        </section>

        {/* Exchanges */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">5. Exchanges</h2>
          <ul className="pp-list">
            <li className="pp-list-item">
              Exchanges are subject to product availability.
            </li>
            <li className="pp-list-item">
              If the requested size or product is unavailable, a refund or store
              credit will be offered.
            </li>
          </ul>
        </section>

        {/* Damaged or Incorrect Items */}
        <section className="pp-content-section">
          <h2 className="pp-section-title">6. Damaged or Incorrect Items</h2>
          <p className="pp-text">
            If you receive a damaged or incorrect product, please contact us
            within 48 hours of delivery with clear images, and we'll resolve it
            at the earliest.
          </p>
        </section>

        {/* Contact */}
        <section className="pp-content-section pp-contact-box">
          <h2 className="pp-section-title">Need Help?</h2>
          <p className="pp-text">
            For any return or refund queries, feel free to reach out:
          </p>
          <div className="pp-contact-grid">
            <div className="pp-contact-card">
              <strong className="pp-contact-label">Email:</strong>
              <a href="mailto:kittynmice00@gmail.com" className="pp-link">
                kittynmice00@gmail.com
              </a>
            </div>
            <div className="pp-contact-card">
              <strong className="pp-contact-label">Phone:</strong>
              <a href="tel:+918076217714" className="pp-link">
                +91 80762 17714
              </a>
            </div>
          </div>
        </section>

        {/* Footer Links */}
        <div className="pp-footer-section">
          <p className="pp-footer-text">Related Policies:</p>
          <div className="pp-footer-links">
            <Link to="/privacy" className="pp-footer-link">
              Privacy Policy
            </Link>
            <Link to="/terms-and-conditions" className="pp-footer-link">
              Terms & Conditions
            </Link>
            <Link to="/shipping-policy" className="pp-footer-link">
              Shipping Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;
